<template>
  <div id="myDateShow">
    <div class="title">查看 优惠券资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">优惠券类型</div>
        <div class="value">{{coupons.couponsType}}</div>
      </div>
      <div class="line" v-if="coupons.couponsType=='固定可叠加'">
        <div class="key">可叠加次数</div>
        <div class="value">
          {{coupons.superpositionCount}}
        </div>
      </div>
      <div class="line">
        <div class="key">优惠券名称</div>
        <div class="value">{{coupons.couponsName}}</div>
      </div>
      <div class="line">
        <div class="key">优惠面值</div>
        <div class="value">
          {{coupons.faceValue}}{{coupons.couponsType=="折扣"?"折":"元"}}
        </div>
      </div>
      <div class="line">
        <div class="key">前6位RNMID码</div>
        <div class="value">{{coupons.rnmIdCode}}</div>
      </div>
      <div class="line">
        <div class="key">自领取后的有效天数</div>
        <div class="value">{{coupons.validityNum}}天</div>
      </div>
      <div class="line">
        <div class="key">创建时间</div>
        <div class="value">
          {{coupons.createDate}}
        </div>
      </div>
      <div class="line">
        <div class="key">最终领取期限</div>
        <div class="value">{{coupons.endReceiveDate}}</div>
      </div>
      <div class="line">
        <div class="key">支持场景</div>
        <div class="value">{{coupons.supportScenarios}}</div>
      </div>
      <div class="line">
        <div class="key">领取场景</div>
        <div class="value">{{coupons.getScenarios}}</div>
      </div>
      <div class="line">
        <div class="key">可用次数</div>
        <div class="value">{{coupons.couponsCount}}次</div>
      </div>
      <div class="line">
        <div class="key">单用户可领取次数</div>
        <div class="value">{{coupons.oneCount}}次</div>
      </div>
      <div class="line">
        <div class="key">被领取总次数</div>
        <div class="value">{{coupons.getCount=='-1'?'无限':coupons.getCount}}次</div>
        <div class="value">
          <el-button type="success" size="small" @click="getReceiveUserByCouponsIdClick">查看领取用户</el-button>
        </div>
      </div>
      <div class="line">
        <div class="key">描述</div>
        <div class="value">{{coupons.describe}}</div>
      </div>

      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getCouponsById,newVue} from "../../network/coupons";

  export default {
    name: "couponsData",
    components: {},
    data(){
      return{
        couponsId:"",
        coupons:{}
      }
    },
    methods:{
      backClick(){
        this.$router.push("../list");
      },
      getReceiveUserByCouponsIdClick(){
        this.$router.push("/userCoupons/list/"+this.couponsId)
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/coupons/list";
      this.common.HeaderLocationTwo.name =  "优惠券管理"
      this.common.HeaderLocationThree.name = "优惠券详情"
      console.log(this.$route.params.id);
      this.couponsId = this.$route.params.id;

      getCouponsById(this.couponsId).then(res => {
        this.coupons = res.data
      })
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
</style>
